//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const SAMPLING_V2_DEFAULT_ENDPOINT = '/api/v2/clients';

export const samplingV2Fetch = (
  endpoint: string,
  init?: RequestInit,
  useFetchHeader?: boolean,
): Promise<ISerializedResponse> =>
  serializedGatewayFetch(
    'sampling_gateway',
    `${SAMPLING_V2_DEFAULT_ENDPOINT}${endpoint}`,
    init,
    useFetchHeader,
  );
